import { ValueOf } from '@/types/common';

export const SESSION_STORAGE_KEYS = {
    OutfitItemsForm: 'OutfitItemsForm',
    OutfitInformationForm: 'OutfitInformationForm',
    CurrentEventGuid: 'CurrentEventGuid',
    Flow: 'Flow',
    EditEventForm: 'EditEventForm',
} as const;

export const LOCAL_STORAGE_KEYS = {
    ClothingForm: 'ClothingForm',
    SeenTooltipsByRoute: 'SeenTooltipsByRoute',
    ConfirmationGuid: 'ConfirmationGuid',
    ClientId: 'ClientId',
    ViewedStoriesKey: 'viewed_stories',
    NewUserFlags: 'NewUserFlags',
    ClothingUploadingWidget: 'ClothingUploadingWidget',
    CanvasOnboardingTour: 'CanvasOnboardingTour',
    TryOnOutfitInfoModalSeen: 'TryOnOutfitInfoModalSeen',
    TryOnOutfitOutputFileGuid: 'TryOnOutfitOutputFileGuid',
    TryOnOutfitGuid: 'TryOnOutfitGuid',
    TryOnDislikedOutfit: 'TryOnDislikedOutfit',
    OutfitSavedModalDisabled: 'OutfitSavedModalDisabled',
    OnboardingShown: 'OnboardingShown',
} as const;

export const COOKIE_KEYS = {
    User: 'user',
    Token: 'token',
    RefreshToken: 'refreshToken',
    UserGuid: 'userGuid',
    ExternalJwt: 'external_jwt',
} as const;

export const STORAGE_KEYS = {
    ...COOKIE_KEYS,
    ...SESSION_STORAGE_KEYS,
    ...LOCAL_STORAGE_KEYS,
} as const;

export type StorageKeyT = ValueOf<typeof STORAGE_KEYS>;
